/**
 * app-search — types + validator for the global search-state of `_app` layout.
 *
 * Centralizes `_app`-level mounted overlays in the URL (currently the
 * multi-account switcher), so pasting the URL into another browser
 * reopens exactly the same screen/overlay.
 *
 * Pattern (same as #9 `/?q=`): `validateSearch` omits defaults (so it does not
 * pollute the URL when empty), and hosts reflect URL→signals + navigate with
 * `{ replace: true }` on open/close (idempotent, survives back/forward and
 * a pasted URL).
 */

export interface AppLayoutSearch {
  // ── Account switch (multi-account #18) ─────────────────────────────────────
  /** Account switcher open (`?account=switch`). */
  account?: "switch";
}

/**
 * Validates + normalizes the layout search. Omits defaults to keep the URL
 * clean. Tolerant: unknown values are discarded (rendering does not break).
 */
export function validateAppLayoutSearch(search: Record<string, unknown>): AppLayoutSearch {
  const out: AppLayoutSearch = {};

  // ── Account switcher (multi-account) ──
  if (search.account === "switch") {
    out.account = "switch";
  }

  return out;
}
